















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";

export default {
    name: "DocumentNonReconnuListFilters",
    components: { TableSort, TableFilters },
    data() {
        return {
            filters: {},
            columns: [
                {
                    id: "emailSender",
                    name: "Expéditeur",
                    type: TableColumn.ColumnType.text,
                    sort_field: "email_sender",
                },
                {
                    id: "originalFilename",
                    name: "Nom du fichier",
                    type: TableColumn.ColumnType.text,
                    sort_field: "original_filename",
                },
                {
                    id: "createdAt",
                    name: "Date d'import",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "created_at",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", _.merge({}, this.filters));
            this.$emit("input", _.merge({}, this.filters));
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
    },
};
